export default {
  inputChange: { width: '420px', backgroundColor: '#f5f5f5', marginTop: '15px' },
  uploadedFile: { borderRadius: '100px', backgroundColor: '#EBEBEB', marginTop: '29px', height: '32px', color: 'black', padding: 2 },
  fileIcon: { color: 'black', width: '25px', height: '25px', margin: '5px 14px 5px 10px' },
  closeIcon: { color: 'white', backgroundColor: '#a5a5a5', borderRadius: '50%', width: '16px', height: '16px', margin: '11px 14px' },
  uploadIcon: { marginRight: '12px' }
}
